import { z } from "zod";
export const ManagerExceptionViewV1Schema = z
    .object({
    schemaVersion: z.literal("manager-exception-view.v1.0"),
    exceptionId: z.string().min(1),
    checkAreaLabel: z.string().min(1),
    reason: z.string().min(1),
    approvedBy: z.string().min(1).optional(),
    approvedAt: z.string().datetime().optional(),
    impactSummary: z.string().min(1),
})
    .strict();
//# sourceMappingURL=manager-exception.js.map